import script from "./WeaponsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeaponsPage.vue?vue&type=script&setup=true&lang=ts"

import "./WeaponsPage.vue?vue&type=style&index=0&id=12581c3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12581c3a"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QTable,QMarkupTable,QIcon});
